export enum TABLE_ACTION {
  INFO,
  DATABASE,
  PLOTS,
  DOWNLOAD
}